import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

// Тумблер тем клиентского приложения: кремовая (ребрендинг) ↔ классическая чёрная.
export const ThemeToggle = ({ compact = false }) => {
  const { theme, toggleTheme } = useTheme();
  const light = theme === "light";

  return (
    <button
      data-testid="theme-toggle"
      onClick={toggleTheme}
      aria-label={light ? "Включить тёмную тему" : "Включить светлую тему"}
      style={{
        display: "inline-flex", alignItems: "center", gap: compact ? 0 : 8,
        background: "var(--ang-surface)", color: "var(--ang-text-soft)",
        border: "1px solid var(--ang-border-strong)", borderRadius: 999,
        padding: compact ? "8px" : "8px 14px", cursor: "pointer",
        fontFamily: "Manrope", fontSize: 11.5, letterSpacing: "0.06em",
        transition: "background-color 0.25s, color 0.25s, border-color 0.25s",
      }}
    >
      {light ? <Moon size={15} /> : <Sun size={15} />}
      {!compact && <span>{light ? "Тёмная тема" : "Светлая тема"}</span>}
    </button>
  );
};
